import colors from '@shared/design-tokens/colors';
import fontStyles from '@shared/design-tokens/fontStyles';

// WRAPPER

const wrapperCSS = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
};

// WRAPPER
const flexWrapperCSS = {
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'center',
};

const labelCSS = {
  ...fontStyles.core.textBasis,
  color: colors.core.darkBlue,
  'margin-bottom': '5px',
};

// CONTAINER
const conatinerCSS = {
  width: '100%',
  marginRight: 'auto',
  marginLeft: 'auto',
};

// COLUMN
const constcolumnCSS = {
  display: 'flex',
  flexDirection: 'column',
};

export {
  wrapperCSS,
  flexWrapperCSS,
  labelCSS,
  conatinerCSS,
  constcolumnCSS,
};
